import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: 'AIzaSyCEwUVZT1ONE9VidlvKv-eBjLSShVCjxS4',
  authDomain: 'eunbro-aaa2c.firebaseapp.com',
  projectId: 'eunbro-aaa2c',
  storageBucket: 'eunbro-aaa2c.firebasestorage.app',
  messagingSenderId: '1024485468644',
  appId: '1:1024485468644:web:81831b7cd19dbea1e5fff1',
  measurementId: "G-WZDRDTXTFH"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);
export { app };